import ChatSection from "@/components/ChatSection";

export default function ChatPage() {
    return (
        <div className="pt-16">
            <ChatSection />
        </div>
    );
}
